import { Routes, Route, useLocation, Navigate } from "react-router";

import Navbar from "../Components/Header/Header";
import Home from "./HomePage/Home";
import Footer from "../Components/Footer/Footer";
import AboutPage from "./About/About";
import ContactUsPage from "./ContactUs/ContactUs";
import UserShop from "./Shop/ShopProduct";
import Blog from "./Blogs/Blog";
import Cart from "../Components/Cart/Cart";

import AdminLogin from "../Admin/Pages/Login";
import AdminHome from "../Admin/Pages/Home";

import whatsappImage from "../Assets/Icons/whatsapp_icon.png";
import Shipping from "./checkout";
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../Redux/action";
// import { showAuth } from "../Redux/action";
import { authPage } from "../Redux/action";
import Loader from "../Components/Loader";
import { useEffect, useState } from "react";
import NewsLetter from "../Admin/Pages/NewsLetter";
import AdminContactUs from "../Admin/Pages/ContactUs";
import AdminUsers from "../Admin/Pages/AdminUsers";
import ShopCommentStatus from "../Admin/Pages/ShopCommentStatus";
import ShopComment from "../Admin/Pages/ShopComment";
import Blogcomment from "../Admin/Pages/BlogComment";
import BlogCommentStatus from "../Admin/Pages/BlogCommentStatus";
import AdminAboutUs from "../Admin/Pages/AboutUs";
import AdminBlog from "../Admin/Pages/Blog";
import AdminShop from "../Admin/Pages/Shop";
import AdminLogout from "../Admin/Pages/Logout";
import AddBlogPost from "../Admin/Pages/AddBlogPost";
import Login from "../Authentication/Login";
import Signup from "../Authentication/SignUp";
import ResetPassword from "../Authentication/ResetPassword";
import ForgotPassword from "../Authentication/ForgotPasword";
import Shop from "./Shop/Shop";
import { AllReviews } from "./Shop/AllReviews";
import CreateUser from "../Admin/Pages/CreateUser";
import Confirmation from "./confirmation";
import MyProfile from "./MyProfile";
import MyAccount from "./MyOrder/MyOrder";
import apiRequest from "../apiCall";

export default function Routing() {
  const isLoading = useSelector((state) => state.loading.isLoading);
  const auth = useSelector((state) => state.showAuth.value);
  const authPage = useSelector((state) => state.authPage.value);
  const adminStoredData = localStorage.getItem("adminData") || null;
  const adminData = adminStoredData ? JSON.parse(adminStoredData) : null;
  const role = adminData ? adminData.Role : null;
  const phoneNumber = "9904336000";

  const handleWhatsAppClick = () => {
    const link = `https://wa.me/${phoneNumber}`;
    window.open(link, "_blank");
  };

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(setLoading(true));
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 200);
  }, [dispatch]);

  const isAdminRoute = location.pathname.startsWith("/admin");
  const isCheckoutRoute = location.pathname.startsWith("/shop/checkout");
  const isConfirmationRoute =
    location.pathname.startsWith("/shop/confirmation");

  const [showFooter, setShowFooter] = useState(false);
  useEffect(() => {
    setShowFooter(false);
    setTimeout(() => {
      setShowFooter(true);
    }, 2000);
  }, [location]);

  const renderRoleBasedComponent = (Component, roles) => {
    return roles.includes(role) ? (
      <Component />
    ) : (
      <Navigate to="/admin/login" />
    );
  };

  return (
    <div>
      {auth && <div className="auth-cover" />}
      {auth ? (
        authPage === "login" ? (
          <Login />
        ) : authPage === "signup" ? (
          <Signup />
        ) : authPage === "forgotPassword" ? (
          <ForgotPassword />
        ) : (
          <ResetPassword />
        )
      ) : null}
      {isLoading && <Loader />}
      {!isAdminRoute && !isConfirmationRoute && !isCheckoutRoute && <Navbar />}
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<UserShop />} />
        <Route path="/see-all-reviews/:id" element={<AllReviews />} />
        <Route path="/blog" element={<Blog post={false} />} />
        <Route path="/blog/:permalink" element={<Blog post />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/shop/checkout" element={<Shipping />} />
        <Route path="/shop/confirmation" element={<Confirmation />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/myorders" element={<MyAccount />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route
          path="/admin/"
          element={
            role === "Admin" || role === "SuperAdmin" ? (
              <AdminHome />
            ) : role === "Blogger" ? (
              <AdminBlog />
            ) : (
              <Navigate to="/admin/login" />
            )
          }
        />
        <Route
          path="/admin/blog"
          element={renderRoleBasedComponent(AdminBlog, [
            "Admin",
            "Blogger",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/blog/add"
          element={renderRoleBasedComponent(AddBlogPost, [
            "Admin",
            "Blogger",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/blog/edit/:_id"
          element={renderRoleBasedComponent(AddBlogPost, [
            "Admin",
            "Blogger",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/logout"
          element={renderRoleBasedComponent(AdminLogout, [
            "Admin",
            "Blogger",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/blogcomment"
          element={renderRoleBasedComponent(Blogcomment, [
            "Admin",
            "Blogger",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/about-us"
          element={renderRoleBasedComponent(AdminAboutUs, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/newsletter"
          element={renderRoleBasedComponent(NewsLetter, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/contactus"
          element={renderRoleBasedComponent(AdminContactUs, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/admin-users"
          element={renderRoleBasedComponent(AdminUsers, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/shopcommentstatus"
          element={renderRoleBasedComponent(ShopCommentStatus, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/shopcomment"
          element={renderRoleBasedComponent(ShopComment, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/blogcommentstatus"
          element={renderRoleBasedComponent(BlogCommentStatus, [
            "Admin",
            "SuperAdmin",
          ])}
        />
        <Route
          path="/admin/shop"
          element={renderRoleBasedComponent(AdminShop, ["Admin", "SuperAdmin"])}
        />
        <Route
          path="/admin/users/create"
          element={renderRoleBasedComponent(CreateUser, ["SuperAdmin"])}
        />
        <Route
          path="/admin/users/edit/:id"
          element={renderRoleBasedComponent(CreateUser, ["SuperAdmin"])}
        />
      </Routes>

      {!isAdminRoute ? (
        <div className="whatsapp-icon">
          <a onClick={handleWhatsAppClick} style={{ cursor: "pointer" }}>
            <img src={whatsappImage} alt="Whatsapp" />
          </a>
        </div>
      ) : (
        <></>
      )}
      {!isAdminRoute &&
        !isConfirmationRoute &&
        !isCheckoutRoute &&
        !isLoading &&
        showFooter && <Footer />}
    </div>
  );
}
